import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Arrow-Right",
  "use": "icon-Arrow-Right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Arrow-Right\">\r\n<g id=\"icon-Arrow-Right_&#228;&#184;&#139;&#230;&#139;&#137;&#230;&#140;&#137;&#233;&#146;&#174;\">\r\n<path id=\"icon-Arrow-Right_Vector 117\" d=\"M6 13L11 8L6 3\" stroke=\"#19191A\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol